<template>
  <div class="header">
    <img src="../assets/header.jpg" alt class="img-fluid" />
    <div class="title-wrapper">
      <h1>{{titulo}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["titulo"]
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  color: #ffffff;
  display: flex;
  align-items: center;
  overflow: hidden;
  & > img {
    width: 100%;
    height: 65.2em;
    object-fit: cover;
    @media (max-width: 669px) {
      height: 35em;
    }
  }

  .title-wrapper {
    position: absolute;
    top: 30%;
    left: 6.8%;
    width: 100%;
    padding-top: 3em;
    padding-left: 3rem;
    @media (max-width: 669px) {
      padding-top: 1em;
      padding-left: 1em;
      top: auto;
      bottom: 17%;
    }

    h1 {
      font-size: 5.2em;
      letter-spacing: 0.019em;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      font-weight: 200;
      color: #ffffff;

      @media (max-width: 480px) {
        font-size: 4.5em;
        line-height: 1em;
        padding-right: 2em;
      }
    }
  }
}
</style>
